import first from 'lodash/first';
import isEmpty from 'lodash/isEmpty';
import last from 'lodash/last';

import { REAL_SIZE_FOR_LUMX_SIZE } from '@lumapps/lumx/constants';
import { Size } from '@lumapps/lumx/react';

// Size of the "ASK AI" button;
const BUTTON_SIZE = REAL_SIZE_FOR_LUMX_SIZE[Size.m];

export const getFloatingButtonPosition = (isPopoverOpen: boolean, currentRange?: Range) => {
    if (currentRange) {
        const rects = currentRange.getClientRects();
        const editorElement = document?.getElementsByClassName('structured-content-editor')?.[0];

        if (editorElement && rects && !isEmpty(rects)) {
            // Get the first element in order to have the button floating on the left-est point of the first line of the selection
            const { x, y } = first(rects) as DOMRect;
            const { x: editorX, y: editorY } = editorElement.getBoundingClientRect();
            const topButtonPosition = y - editorY - BUTTON_SIZE;

            /**
             * If the popover is open, hide the button and place it at the left-end of the selection
             * because we use it as an anchor for the popover.
             */
            if (isPopoverOpen && currentRange) {
                // Get the selection heigth to position the popover under it
                // const rect = domSelection.getRangeAt(0)?.getBoundingClientRect();
                const rect = currentRange.getBoundingClientRect();
                const { height } = rect;

                // Get the last element in order to have the last line position of the selection
                const { x: xBis } = last(rects) as DOMRect;

                return {
                    left: xBis - editorX,
                    top: topButtonPosition + height,
                    // Hide the button if the popover is open
                    // We use it as ref for the popover position
                    visibility: 'hidden',
                };
            }

            return {
                left: x - editorX,
                top: topButtonPosition,
            };
        }
        return { visibility: 'hidden' };
    }

    return { visibility: 'hidden' };
};
